import { BottomNav } from "./BottomNav";
import { Container } from "./Container";
import { TopBar } from "./TopBar";
import { Breadcrumbs } from "@/components/kit/Breadcrumbs";
import { PreviewBanner } from "@/components/kit/PreviewBanner";
import { SHELL } from "@/constants/testIds";

export const AppShell = ({
  title,
  subtitle,
  showBack,
  action,
  slug,
  todayHref,
  crumbs,
  nav = true,
  size = "wide",
  children,
}) => (
  <div data-testid={SHELL.root} className="ps-grain flex min-h-screen flex-col bg-background">
    <TopBar title={title} subtitle={subtitle} showBack={showBack} action={action} />
    <PreviewBanner />
    <main className="relative z-10 flex-1 pb-16 pt-6 sm:pt-8">
      {/* 32px rhythm between floating sections */}
      <Container size={size} className="ps-rise flex flex-col gap-5 sm:gap-7">
        {/* Breadcrumbs are a desktop affordance — on mobile the top bar and back arrow are enough. */}
        {crumbs?.length > 1 && <Breadcrumbs items={crumbs} className="hidden sm:flex" />}
        {children}
      </Container>
    </main>
    {nav && <BottomNav slug={slug} todayHref={todayHref} />}
  </div>
);
